import { render, staticRenderFns } from "./Glosario.vue?vue&type=template&id=3da05b61&"
import script from "./Glosario.vue?vue&type=script&lang=js&"
export * from "./Glosario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports